import Typography from '~/shared/components/Typography';
import Loader from '~/shared/components/Loader';

import VolumeInfoCard from './VolumeInfoCard';

import type { Volume } from '~/shared/types/api';

interface VolumeGridProps {
  volumes: Volume[];
  searchQuery: string;
  onCreateException?: (volumeId: string) => void;
  onRemoveException?: (volumeId: string, volumeName?: string) => void;
  volumeType?: 'matching' | 'exception' | 'potential';
  isLoading?: boolean;
}

export default function VolumeGrid({
  volumes,
  searchQuery,
  onCreateException,
  onRemoveException,
  volumeType,
  isLoading = false,
}: VolumeGridProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <Loader variant="lg" />
      </div>
    );
  }

  if (volumes.length === 0) {
    return (
      <div className="flex items-center justify-center py-8">
        <Typography variant="p3-reg" color="text-gray-500">
          {searchQuery.trim() ? 'No volumes match your search' : 'No volumes found'}
        </Typography>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-[5px]">
      {volumes.map((volume) => (
        <VolumeInfoCard
          key={volume.volumeId}
          volume={volume}
          onCreateException={onCreateException}
          onRemoveException={onRemoveException}
          volumeType={volumeType}
        />
      ))}
    </div>
  );
}
